import React from 'react';

const Interests = () => {
  return (
    <section id="interests">
      <h2>Interests</h2>
      <p>
        <li>Big Data</li>
        <li>Machine Learning/AI</li>
        <li>Software Development</li>
      </p>
    </section>
  );
};

export default Interests;